import {
  createKeyvalStorage,
  createKeyvalView,
} from '$logic/lib/keyval.storage'

interface DataAndStorage {
  autoDownload: boolean
  autoPlayAudio: boolean
}

const key = 'data-and-storage'

export const dataAndStorageStorage = createKeyvalStorage<DataAndStorage>(key)

export const dataAnsStorageView = createKeyvalView<DataAndStorage>(key)
